import React from "react";
import { Button, Table } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faFile, faSearch, faTrash } from "@fortawesome/free-solid-svg-icons";

class FileOverviewTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.fileState = [
      <span className="fa-layers fa-fw" key={1}>
        <FontAwesomeIcon icon={faFile} size="xs" className="color-red" />
        <FontAwesomeIcon icon={faSearch} size="lg" className="color-black" />
      </span>,
      <FontAwesomeIcon key={2} icon={faCheck} className="color-green" />
    ];

    this.humanReadableFileSize = this.humanReadableFileSize.bind(this);
  }

  humanReadableFileSize(size) {
    const labels = ["B", "KB", "MB", "GB"];
    let ct = 0;
    while (size > 1024 && ct < labels.length) {
      size /= 1024;
      ct++;
    }
    return `${Math.round(size * 100) / 100} ${labels[ct]}`;
  }

  render() {
    const { t } = this.props;
    const elements =
      this.props.studentFileProposals.length > 0 ? (
        this.props.studentFileProposals.map((i, idx) => (
          <tr key={idx}>
            <td>{i.name}</td>
            <td>{this.humanReadableFileSize(i.size)}</td>
            <td>{this.fileState[i.isAccepted ? 1 : 0]}</td>
            <td>
              {!i.isAccepted ? (
                <div className="floatRight">
                  <Button
                    className="btn btn-sm btn-red"
                    disabled={i.isAccepted}
                    onClick={() => this.props.onDelete(i._id)}
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </Button>
                </div>
              ) : (
                ""
              )}
            </td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan="4">
            {t(
              "ExaminationAccess.UploadManagerDialog.FileOverviewTab.NoUploadsFound"
            )}
          </td>
        </tr>
      );
    return (
      <div>
        <div className="mt-2">
          <ul style={{ listStyle: "none", padding: "0px" }}>
            <li>
              <FontAwesomeIcon icon={faCheck} className="color-green mr-2" />
              {t(
                "ExaminationAccess.UploadManagerDialog.FileOverviewTab.AcceptedFile"
              )}
            </li>
            <li>
              <span className="fa-layers fa-fw mr-2">
                <FontAwesomeIcon
                  icon={faFile}
                  size="xs"
                  className="color-red"
                />
                <FontAwesomeIcon
                  icon={faSearch}
                  size="lg"
                  className="color-black"
                />
              </span>
              {t(
                "ExaminationAccess.UploadManagerDialog.FileOverviewTab.FileUnderReview"
              )}
            </li>
          </ul>
        </div>
        <Table size="sm mt-2">
          <thead>
          <tr>
            <th>
              {t(
                "ExaminationAccess.UploadManagerDialog.FileOverviewTab.ColumnFilename"
              )}
            </th>
            <th>
              {t(
                "ExaminationAccess.UploadManagerDialog.FileOverviewTab.ColumnFileSize"
              )}
            </th>
            <th />
            <th />
          </tr>
          </thead>
          <tbody>{elements}</tbody>
        </Table>
      </div>
    );
  }
}

export default withTranslation()(FileOverviewTab);
